///<reference path="typings/dotvvm/DotVVM.d.ts"/>

import { saveDarkMode, updateTwitterTheme } from './darkMode'
import { initNav } from './navigation'
import { initSvgParser } from './svgParser'

const $ = (window as any).jQuery
const twttr = require('twitter-widgets');
const dotvvm = (window as any).dotvvm

const tabletWidth = 1024
const panelButton = document.getElementById('panelButton')
const twitterWall = document.getElementById('twitter-widget-0')

function collapsePanel() {
    const panelCollapsed = document.querySelector('.panel__header--collapsed') != null

    if (window.innerWidth <= tabletWidth && !panelCollapsed) {
        setTimeout(function () {
            panelButton.click()
        }, 1)
    }
}

dotvvm.events.init.subscribe(() => {
    initSvgParser()
    initNav()

    dotvvm.viewModels.root.viewModel.IsDarkModeEnabled.subscribe(() => {
        saveDarkMode()

        if (twitterWall) {
            updateTwitterTheme()
            twttr.widgets.load()
        }
    });

    if (panelButton) {
        collapsePanel()
    }
}) 